<div class="mb-3" i18n="events showroom intro message">
  Those are currently active deals, select your location to see more!
</div>
<app-event-list [events]="events"></app-event-list>
